export { default } from './Footer';
export * from './types';
